import { render } from "./card-header.vue?vue&type=template&id=71ce0be6&scoped=true"
import script from "./card-header.vue?vue&type=script&lang=js"
export * from "./card-header.vue?vue&type=script&lang=js"

import "./card-header.vue?vue&type=style&index=0&id=71ce0be6&scoped=true&lang=less"

import exportComponent from "/home/runner/work/i/i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ce0be6"]])

export default __exports__